import { Divider } from '@mui/material';
import * as React from 'react';
import * as TFF from '@tff/types/TFF';
import { useIntl } from 'react-intl';
import TFFTypography from '../../styled-components/TFFTypography';
import { useBookingContext } from '../../hooks/use-booking-context';
import { isAtcomresBooking } from '../../util/booking-type-utils';

interface TotalAndBalanceProps {
  midocoFlightDetails: TFF.FlightDetails | undefined;
  totalBookingPrice: number;
  retrieveDb?: TFF.BookedRetrieve;
}

const TotalAndBalance: React.FC<TotalAndBalanceProps> = ({ midocoFlightDetails, totalBookingPrice, retrieveDb }) => {
  const intl = useIntl();
  const { numberFormatter } = useBookingContext();

  const paymentsAmount = midocoFlightDetails?.OrderDetails?.Payments?.length
    ? Number(midocoFlightDetails?.OrderDetails?.Payments[0].Amount)
    : 0.0;

  const calculateOutstanding = (): number => {
    if (isAtcomresBooking(retrieveDb)) {
      const paymentSplit = retrieveDb?.reservationSystemDetails?.atcomres_cr?.paymentSplit;
      const finalPayment = paymentSplit?.find(payment => payment.type === 'final');
      const amount = finalPayment?.amount ?? 0;
      return amount !== 0 ? -amount : 0;
    }
    return paymentsAmount - totalBookingPrice;
  };

  const calculateAlreadyCharged = (): string => {
    if (isAtcomresBooking(retrieveDb)) {
      const paymentSplit = retrieveDb?.reservationSystemDetails?.atcomres_cr?.paymentSplit;
      const depositPayment = paymentSplit?.find(payment => payment.type === 'deposit');
      return numberFormatter.format(depositPayment?.amount ?? 0);
    }
    return midocoFlightDetails?.OrderDetails?.Payments?.length
      ? numberFormatter.format(midocoFlightDetails.OrderDetails.Payments[0].Amount)
      : '';
  };

  const outstanding = calculateOutstanding();
  const alreadyCharged = calculateAlreadyCharged();

  return (
    <>
      <div className="tff-pricing-details-container">
        <Divider
          sx={{
            backgroundColor: '#BABABA',
            height: '2px',
            marginBottom: '10px',
            marginTop: '-15px',
          }}
        />
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <TFFTypography fontWeight="bold" text={intl.formatMessage({ id: 'pricingDetails.total' })} />
          <TFFTypography fontWeight="bold" text={numberFormatter.format(totalBookingPrice)} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <TFFTypography text={intl.formatMessage({ id: 'pricingDetails.alreadyCharged' })} />
          <TFFTypography text={alreadyCharged} />
        </div>{' '}
      </div>
      <div className="tff-balance-container">
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <TFFTypography fontWeight="bold" text={intl.formatMessage({ id: 'pricingDetails.outstanding' })} />
          <TFFTypography
            fontWeight="bold"
            extraStyle={{ color: outstanding < 0 ? 'red' : 'white' }}
            text={numberFormatter.format(outstanding)}
          />
        </div>
      </div>
    </>
  );
};

export default TotalAndBalance;
